var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_vm._v(" tagoptions "),_c('b',[_vm._v(_vm._s(_vm.kip))])]),_vm._v(" xxx: "+_vm._s(_vm.treenodes)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }